export * from "./TileLeMag";
import TileLeMag from "./TileLeMag";
export default TileLeMag;
